import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';

/**
 * Dashboard statistics from API
 */
export interface DashboardStats {
  devices: {
    total: number;
    active: number;
    inactive: number;
    online: number;
    stale: number;
  };
  drift: {
    high: number;
    medium: number;
    low: number;
    none: number;
    total: number;
    hasIssues: boolean;
  };
  software: {
    totalUnique: number;
    allowed: number;
    dangerous: number;
    unknown: number;
    topDangerous: Array<{
      name: string;
      publisher: string | null;
      deviceCount: number;
      severity: string;
      category: string | null;
    }>;
    hasIssues: boolean;
  };
  sync: {
    enabled: boolean;
    lastRunAt: string | null;
    lastRunStatus: string | null;
    nextRunAt: string | null;
    isRunning: boolean;
  };
  fog: {
    connected: boolean;
    hostCount: number;
    activeTasks: number;
    error?: string;
  };
  recentActivity: {
    recentDevices: Array<{
      hostname: string;
      updatedAt: string | null;
    }>;
  };
}

/**
 * Hook to fetch dashboard statistics
 */
export function useDashboard() {
  return useQuery({
    queryKey: ['dashboard'],
    queryFn: async () => {
      return api.get<DashboardStats>('/api/v1/dashboard');
    },
    refetchInterval: 60000, // Refresh every minute
  });
}
